module.exports = __webpack_public_path__ + "img/image-about-dark.fa292a67.jpg";